import styled from "styled-components";

export const Text = styled.div`
  font-size: 10px;
  line-height: 12px;
  margin-bottom: 10px;
  & a, a:active, a:hover, a:visited {
    color:#456dd6;
  }
`;
export const TextBtn = styled.div`
  font-size: 10px;
  line-height: 12px;
  margin-bottom: 10px;
  text-align: right;
  /* float: right; */
  cursor: pointer;
`;
